import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import DropDown from "../../../../Filters/DropDown";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";
import { ISunsetData } from "./SunsetDetailInfo";
import {
  sunsetDetailDataState,
  VerticalTableLabel,
  VerticalTableRow,
  VerticalTableValue,
} from "./SunsetSubs";

export default function NotifyType() {
  const location = useLocation() as unknown as ISunsetData;
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  const [sunsetDetailData, setSunsetDetailData] = useRecoilState(
    sunsetDetailDataState
  );

  const [notifyType, setNotifyType] = useState({
    // 통지 횟수
    value: location?.state ? `${location?.state?.sunsetData?.notifyType}` : "",
    label: location?.state
      ? location?.state?.sunsetData?.notifyType === 1
        ? "2회"
        : location?.state?.sunsetData?.notifyType === 2
        ? "매일"
        : ""
      : "선택",
  });

  // 통지 횟수
  const notifyTypeOption = [
    { value: "1", label: "2회" },
    { value: "2", label: "매일" },
  ];

  useEffect(() => {
    if (notifyType?.value !== "") {
      setSunsetDetailData({
        ...sunsetDetailData,
        notifyType: +notifyType?.value!,
      });
    }
  }, [notifyType]);

  return (
    <VerticalTableRow>
      <VerticalTableLabel>통지 횟수</VerticalTableLabel>

      {buttonType === "view" ? (
        <VerticalTableValue>{notifyType?.label}</VerticalTableValue>
      ) : (
        <DropDown
          optionList={notifyTypeOption}
          dropdownValue={notifyType}
          setDropDownValue={setNotifyType}
        />
      )}
    </VerticalTableRow>
  );
}
